import { Component, computed, input } from '@angular/core';
import { EmailDetails } from '../../services/document-email.service';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-docket-link',
  standalone: true,
  imports: [RouterLink],
  template: `
    <a [routerLink]="link()">{{ linkText() }} {{ email().emailable_id }}</a>
  `,
  styles: ``
})
export class DocketLinkComponent {
  email = input.required<EmailDetails>();

  link = computed(() => {
    switch (this.email().emailable_type) {
      case 'docket':
        return `/docket/${this.email().emailable_id}`;
      case 'saleDocket':
        return `/sale-docket/${this.email().emailable_id}`;
      case 'booking':
        return `/bookings/view/${this.email().emailable_id}`;
      default:
        return '';
    }
  });

  linkText = computed(() => {
    switch (this.email().emailable_type) {
      case 'docket':
        return 'Hire';
      case 'saleDocket':
        return 'Sale';
      case 'booking':
        return 'Booking';
      default:
        return 'Unknown';
    }
  });
}
